import { isLitePerf, isWebView, isLowEndDevice } from '@tasted/utils/perfTier';
import { canAfford3D, netTierDebug } from '@tasted/utils/netTier';
import { bottleAssetFor } from '@tasted/utils/bottleAssets';

// Every model ships with the game, under public/models, and is served by the
// game's own host. Vercel Blob paused this account's store on 18 Oct 2026 (Hobby
// limit), and Supabase storage is on the free plan, so neither carries them.
// A new model gets a new filename so cached copies never go stale.

// Two separate questions, and a no from either one is a no (TAS-398):
//   can this DEVICE draw it   — isLitePerf
//   can this CONNECTION fetch it — canAfford3D, including the model and lighting
// Returning null here is all it takes: RevealBottle falls back to the photo
// (with hold-to-zoom) and TastingNotesSheet to its gradient, both tested paths.
export function bottleModelFor(wineId) {
  if (isLitePerf() || !canAfford3D()) return null;
  return bottleAssetFor(wineId);
}

export const getBottleModelUrl = bottleModelFor;

/**
 * The same decision as bottleModelFor, with the reason attached, so the reveal
 * can say WHY a phone got the photograph (prod 2476, 2026-10-02: nothing
 * recorded what the phones had measured).
 */
export function bottleGate(wineId) {
  const modelUrl = bottleAssetFor(wineId);
  if (!modelUrl) return { modelUrl: null, reason: 'no-model' };
  if (isLitePerf()) {
    const reason = isWebView() ? 'webview' : isLowEndDevice() ? 'low-end-device' : 'lite-override';
    return { modelUrl: null, reason };
  }
  if (!canAfford3D()) return { modelUrl: null, reason: 'net-tier' };
  return { modelUrl, reason: null };
}

/** What the two gates saw on this device, PII-free, for analytics and /check. */
export function deviceTelemetry() {
  const n = typeof navigator !== 'undefined' ? navigator : {};
  const net = netTierDebug();
  return {
    device_memory: typeof n.deviceMemory === 'number' ? n.deviceMemory : null,
    hardware_concurrency: typeof n.hardwareConcurrency === 'number' ? n.hardwareConcurrency : null,
    webview: isWebView(),
    lite_perf: isLitePerf(),
    net_tier: net.tier,
    net_measured: net.measured,
    net_kbps: net.kbps,
    net_samples: net.samples,
    net_big_samples: net.bigSamples,
    net_hint: net.hint,
    net_cap: net.sessionCap,
    net_override: net.override,
    // Whether the newest speed reading from our own fetches was used, or set
    // aside as a cache read (TAS-526), and whether Data Saver capped the tier.
    net_fetch_sample: net.lastFetchSample,
    net_save_data: net.saveData,
  };
}
